import React, {useState, useEffect, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import { AuthContext } from '../../context/AuthContext'
import { getVacationsHistory, cancelVacations } from '../../services/VacationHistoryService';
import Loader from '../common/Loader';
import { VacationsContext } from '../../context/VacationsContext';
import { deleteEvent } from '../../services/CalendarService';
import dayjs from 'dayjs';

const EmployeeVacationsList = ({ year, userId }) => {

    const { accessToken } = useContext(AuthContext);
    const [vacations, setVacations] = useState([])
    const [pending, setPending] = useState(true);
    const { updateParent, setUpdateParent } = useContext(VacationsContext);

    const showData = async () => {
        const res = await getVacationsHistory(userId, year, false);
        let data = [];
        let formatStartDate;
        let formatEndDate;
        for (const key in res) {
            if (res[key].start_date !== null) {
                formatStartDate = dayjs(res[key].start_date).format("DD/MM/YYYY");
                formatEndDate = dayjs(res[key].end_date).format("DD/MM/YYYY");
            }
            data.push({
                start_date: formatStartDate,
                end_date: formatEndDate,
                status: res[key].status,
                total_days: res[key].total_days,
                remaining_days: res[key].remaining_days,
                vacations_id: res[key].vacations_id,
                request_date: res[key].request_date,
                comment: res[key].comment,
                event_id: res[key].calendar_event_id
            })
        }
        setVacations(data)
    }

    const cancelVacationsById = async (id) => {    
        let formData = {
            vacations_id: id
        }
        await cancelVacations(JSON.stringify(formData));
    }

    useEffect(() => {
        (async () => {
            const data = await showData();
            if (data) {
                setVacations(data);
            }
            setPending(false)
        })();
    }, [year, updateParent])

    const columns = [
        {
            name: 'Fecha Inicio',
            selector: row => row.start_date
        },
        {
            name: 'Fecha Fin',
            selector: row => row.end_date
        },
        {
            name: 'Status',
            selector: row => row.status
        },
        {
            name: 'Días',
            selector: row => row.total_days
        },
        {
            name: 'Días restantes',
            selector: row => row.remaining_days
        },
        {
            name: 'Fecha de petición',
            selector: row => row.request_date
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    { (row.status === 'GRANTED') &&
                        row.comment
                    }
                </div>
            ),
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    { (row.status === 'PENDING' || row.status === 'APPROVED') &&
                        <Button variant="outline-danger" onClick={() => {
                            deleteCalendarEvent(accessToken, row.event_id);
                            cancelVacationsById(row.vacations_id);
                            setUpdateParent(row.vacations_id);
                        }}>Cancelar</Button>
                    }
                </div>
            ),
        }
    ]

    return (
        <div className="App table">
            <DataTable
                columns={columns}
                data={vacations}
                striped={true}
                progressPending={pending}
                progressComponent={<Loader />}
                pagination
            />
        </div>
    );
}

const deleteCalendarEvent = async (access_token, event_id) => {
    let formData = {
        access_token: access_token,
        event_id: event_id
    }
    console.log(formData);
    await deleteEvent(JSON.stringify(formData));
}

export default EmployeeVacationsList;